import { Button, FlexBox, Icon, Text } from '@fable/components'
import { css, useTheme } from '@fable/theme'
import { useStats } from '../lib/ctx/stats'
import { OverflowMenu } from './shared'
import { useState } from 'react'
import { analytics } from 'segment_analytics'
import { useReaderSummary } from '../lib/ctx/reader_summary'

export const StatsYearSelector = () => {
  const { colors } = useTheme()
  const [isProfileView, setYear, year, getStatsV2, yearList] = useStats((s) => [
    s.isProfileView,
    s.setYear,
    s.year,
    s.getStatsV2,
    s.yearList,
  ])
  const updateSummary = useReaderSummary((s) => s.updateSummary)
  const [open, setOpen] = useState(false)

  const onSelectYear = async (y: number) => {
    if (year === y) return

    setOpen(false)

    analytics.events.stats.statsYearChanged({ year: y })

    setYear(y)

    const stats = await getStatsV2({ status: 'loadingYear' })

    if (stats) updateSummary(stats)
  }

  return (
    <div>
      <OverflowMenu
        dataTestId="stats-menu-button"
        open={open}
        setOpen={setOpen}
        wrapperStyles={css`
          top: 48px;
        `}
        containerStyles={css`
          padding-bottom: 8px;
          max-height: 250px;
        `}
        align="left"
        trigger={
          <Button
            className={css`
              width: auto;
              height: 40px;
              gap: 16px;
              padding: 0 12px;
              justify-content: space-between;
              background-color: ${open ? colors.uiGraphite : colors.uiBlack20};
              border: none;
              &:hover {
                background-color: ${open
                  ? colors.uiGraphite
                  : colors.uiBlack20};
              }
            `}
          >
            {year}
            <Icon
              type="chevron"
              className={css`
                width: 10px;
              `}
              fill={colors.uiWhite}
            />
          </Button>
        }
        size={isProfileView ? 'S' : 'M'}
      >
        {!yearList.length ? (
          <div>
            <Text
              className={css`
                padding: 0 12px 12px;
              `}
              type="label"
              sizing="L"
              color={colors.uiWhite}
              weight="500"
            >
              You have no stats in other years.
            </Text>
          </div>
        ) : (
          <FlexBox
            className={css`
              width: 100%;
              gap: 10px;
            `}
            flexDirection="column"
          >
            <div>
              <Text
                className={css`
                  padding: 0 12px;
                `}
                type="label"
                sizing="L"
                color={colors.uiPewterGrey}
              >
                Select stats year
              </Text>
              <ul
                className={css`
                  margin-top: 5px;
                `}
              >
                {yearList.map((value) => {
                  const selected = value === year

                  return (
                    <li
                      key={value}
                      className={css`
                        padding: 0 20px 0 12px;
                        height: 32px;
                        display: flex;
                        align-items: center;
                        cursor: pointer;
                      `}
                      onClick={() => onSelectYear(value)}
                    >
                      <FlexBox
                        className={css`
                          width: 100%;
                        `}
                        as="span"
                        alignItems="center"
                        gap="8px"
                      >
                        <Text type="body" sizing="M" color={colors.uiWhite}>
                          {value}
                        </Text>
                      </FlexBox>
                      <Icon
                        className={css`
                          flex-shrink: 0;
                          opacity: ${selected ? 1 : 0};
                        `}
                        type="tick"
                        fill={colors.uiWhite}
                      />
                    </li>
                  )
                })}
              </ul>
            </div>
          </FlexBox>
        )}
      </OverflowMenu>
    </div>
  )
}
